/* eslint-disable max-len */
import React from 'react';

const Sale01: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="sale-01" clipPath="url(#clip0_10156_8026)">
      <path id="Icon" d="M7.49996 7.49935H7.50829M12.5 12.4993H12.5083M13.3333 6.66602L6.66663 13.3327M18.3333 9.99935C18.3333 14.6017 14.6023 18.3327 9.99996 18.3327C5.39759 18.3327 1.66663 14.6017 1.66663 9.99935C1.66663 5.39698 5.39759 1.66602 9.99996 1.66602C14.6023 1.66602 18.3333 5.39698 18.3333 9.99935ZM7.91663 7.49935C7.91663 7.72947 7.73008 7.91602 7.49996 7.91602C7.26984 7.91602 7.08329 7.72947 7.08329 7.49935C7.08329 7.26923 7.26984 7.08268 7.49996 7.08268C7.73008 7.08268 7.91663 7.26923 7.91663 7.49935ZM12.9166 12.4993C12.9166 12.7295 12.7301 12.916 12.5 12.916C12.2698 12.916 12.0833 12.7295 12.0833 12.4993C12.0833 12.2692 12.2698 12.0827 12.5 12.0827C12.7301 12.0827 12.9166 12.2692 12.9166 12.4993Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_10156_8026">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Sale01;
